import { FC, useEffect, useRef } from 'react'
// TODO typescript 오류 수정 필요
// @ts-ignore
import DaumPostcode, { AddressData } from 'react-daum-postcode'
import { isFirefox, isMobile } from 'react-device-detect'
import { Modal } from '@/components/common'
import { ModalBaseProps } from '@/components/common/modals/ModalBase'
import { Typo, TypoVariant } from '@/components/common/typography'
import { FieldKeysEnum } from '@/constants/field-keys.enum'
import { localPostCode } from '@/utils/utilLocalStorage'

type ModalDaumPostcodeProps = {} & ModalBaseProps<any>

const handleResult = (data: AddressData) => {
  let fullAddress = data.address
  let extraAddress = ''

  if (data.addressType === 'R') {
    if (data.bname !== '') {
      extraAddress += data.bname
    }
    if (data.buildingName !== '') {
      extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
    }
    fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
  }

  return {
    [FieldKeysEnum.BasicAddress]: fullAddress,
    [FieldKeysEnum.PostNumber]: data.zonecode,
    [FieldKeysEnum.DetailAddress]: '',
  }
}

const ModalDaumPostcode: FC<ModalDaumPostcodeProps> = ({ useModalProps }) => {
  const { visible, setActionParams, hideModal } = useModalProps
  /** 모달이 열린 시점의 history 엔트리 수. 닫힌 상태에서는 null */
  const startHistoryLengthRef = useRef<number | null>(null)

  /**
   * 우편번호 위젯(iframe)은 검색할 때마다 부모 히스토리에 엔트리를 쌓는 브라우저가 있어(Chrome 등),
   * 그대로 두면 이후 router.back() 이 잔여 엔트리만 소비해 화면이 이동하지 않는다.
   * 이를 막기 위해 모달이 닫힐 때(완료/취소 공통) 실제 늘어난 엔트리 수만큼 되돌린다.
   *
   * 단, Firefox 는 iframe 이 제거되면 iframe 이 쌓은 엔트리를 브라우저가 비동기로 정리하므로
   * 되돌림이 필요 없다. 이 시점에 measured delta 는 정리 전 값이라, 되돌리면 실제 페이지까지
   * back 되어 버린다(#1231과 동일 증상). 따라서 Firefox 에서는 되돌림을 건너뛴다.
   */
  useEffect(() => {
    if (visible) {
      startHistoryLengthRef.current = window.history.length
      return
    }
    if (startHistoryLengthRef.current === null) {
      return
    }
    const delta = window.history.length - startHistoryLengthRef.current
    startHistoryLengthRef.current = null
    if (delta > 0 && !isFirefox) {
      window.history.go(-delta)
    }
  }, [visible])

  return (
    <Modal useModalProps={useModalProps} buttonType="CANCEL" cancelText="닫기" backAction={false} noBackBehavior>
      <DaumPostcode
        style={{ height: isMobile ? '480px' : '650px' }}
        onComplete={(data) => {
          const actionParams = handleResult(data)
          localPostCode.save(actionParams)
          setActionParams(actionParams)
          hideModal()
        }}
        autoClose
      />
    </Modal>
  )
}

export default ModalDaumPostcode
